import { render, staticRenderFns } from "./profileSubscriptions.vue?vue&type=template&id=da4a3a32&scoped=true"
import script from "./profileSubscriptions.vue?vue&type=script&lang=js"
export * from "./profileSubscriptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da4a3a32",
  null
  
)

export default component.exports